<div [hidden]="hasBeenShown" [class.show]="showIt" id="cookie-consent">
  <div class="flag-container">
    <img
      src="/assets/images/logos/european-flag.png"
      alt="European Union Flag"
      class="flag"
    />
  </div>
  <div class="cookie-desc">
    <span class="title">This website use cookies</span>
    <br />
    <span class="sub-desc">
      We use cookies to analyse our traffic. We also share information about your use of our site with our analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services.
    </span>
    <div class="button-container">
      <button class="wrapper cookie-button gray-btn" (click)="closeModal()">
        <a style="cursor: pointer">
          Reject cookies
        </a>
      </button>
      <button class="wrapper cookie-button" (click)="iGotIt()">
        <a style="cursor: pointer">
          Allow cookies
        </a>
      </button>
    </div>
    <div class="details" style="margin-right: 0">
      <a aria-label="Terms of Use" href="/terms-of-use" target="_blank">
        Privacy Policy
      </a>
      &
      <a aria-label="Privacy policy" href="/privacy-policy" target="_blank">
        Terms of Services
      </a>
    </div>
  </div>
  <button class="wrapper close-btn" (click)="closeModal()">
    <a aria-label="Close modal">×</a>
  </button>
</div>
